<template>
  <div>
	<div class="data6">
		<div class="data6Left">
			<div class="data6LeftTil">
				新兴技术·安全无忧
			</div>
			<div class="data6LeftBox">
				<div class="data6LeftFor" v-for="(item,index) in byzlList" :key="index">
					<div class="data6LeftForImg">
						<img :src="item.img" />
					</div>
					<div class="data6LeftForName">
						{{item.name}}
					</div>
					<div class="data6LeftForCen">
						{{item.cen}}
					</div>
				</div>
			</div>
		</div>
		<div class="data6Right">
			<img src="@/assets/product/page2/czjyZlys.png" />
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		byzlList: [{
				img: require('@/assets/product/page7/jgcs.png'),
				name: '激光传输',
				cen: '- 高速率激光传输可呈现更多细节信息，使图像更细腻- 进一步增强绝缘强度，提高抗干扰性和稳定性'
			},
			{
				img: require('@/assets/product/page7/wxgd.png'),
				name: '无线供电',
				cen: '- 实现无接触式供电，避免漏电风险- 免受高频电刀或周边设备干扰，为安全诊疗保驾护航'
			},
		]
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data6{
	display: flex;
	padding-bottom: 150px;
	.data6Left{
		flex:1;
		padding-left: 200px;
		.data6LeftTil{
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 70px;
		}
		.data6LeftBox{
			display: flex;
			flex-wrap: wrap;
			width: 100%;
			.data6LeftFor{
				width: calc(49% - 40px);
				padding: 0 20px;
				margin-bottom: 70px;
				.data6LeftForImg{
					margin-bottom: 42px;
					img{
						width: 70px;
						height: 70px;
					}
				}
				.data6LeftForName{
					margin-bottom: 32px;
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
				}
				.data6LeftForCen{
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}
	.data6Right{
		flex:1;
		img{
			width: 100%;
			height: 600px;
			object-fit: cover;
		}
	}
}
</style>
